import React, { useEffect, useState } from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
    dispatchSkills,
    dispatchPskills,
    cert_function,
    updateSkills,
    updateSoft_skills,
    generate_my_cv,
    saveSkills,
    returnHome,
    existing_resume,
    save_secret,
    updateProfileLanguage,
    resume_step_jump_function,
    combine_skills
  } from "../../../Redux/ActionCreator";
import { ToastContainer, toast } from "react-toastify";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { capitalize, capitalizeWords } from '../../../utils/capitalize/capitalizeWord';

const EditSkill= ({ handleClick }) => {
  const dispatch = useDispatch();
  const language_data = useSelector((lan) => lan.language);
  const profile1 = useSelector((e) => e.login);
  const userInfo = useSelector((e) => e.userInfo);
  let stat = profile1.profile_status.profile_status;
  const secret = useSelector((prev) => prev.secret);
  const lang_data = useSelector((lan) => lan.lang);
  const Tech_skills = useSelector((e) => e.skills);
  const Personal_skills = useSelector((e) => e.p_skills);
  const p_profile = useSelector((e) => e.profile);
  const flowLanguage = useSelector(e => e.t_lang.selected);

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [customLanguage, setCustomLanguage] = useState(null);

  const [skills, setSkills]  = useState([
    // 'Plumbing', 'Plumbing', 'Plumbing', 'Plumbing', 'Cleaning', 'Gardening',
    // 'Plumbing', 'Dry cleaning', 'Plumbing', 'Plumbing', 'Plumbing', 'Plumbing',
    // 'Plumbing', 'Plumbing', 'Plumbing', 'Cleaning', 'Plumbing'
  ]);

  const [selectedSkills, setSelectedSkills] = useState([]);
  const [customSkills, setCustomSkills] = useState(null);

  const handleSkillClick = (skill) => {
      if (selectedSkills.includes(skill)) {
        setSelectedSkills(selectedSkills.filter(s => s !== skill));
      } else {
        if (selectedSkills?.length < 8) {
          setSelectedSkills([...selectedSkills, skill]);
        } else {
          setTimeout(() => {
            toast.error("You have reach maximum skills you can select", {
                position: toast.POSITION.TOP_RIGHT,
            });
          }, 50);
        }
      }
  };

  useEffect(() => {
    // dispatch(combine_skills(selectedSkills))
    // save into server cache
    let saveToCache = async () => {
      await saveIntoServerCache("technicalSkills", selectedSkills);
    }
    saveToCache();
  }, [selectedSkills])

  useEffect(() => {
    if (!window.location.pathname.includes("/user/profile")) {
      if (Tech_skills?.skills !== null) {
        let tSkills = [ ...new Set(Tech_skills?.skills?.map(e => (e?.value != undefined ? e?.value : e)))];
        // skills.push(...tSkills, ...pSkills);
        let displayedSkills = [...new Set([...tSkills])];
        let displayedSelectedSkills, newSkills = [];
        if (displayedSkills?.length > 15) {
          newSkills = displayedSkills.slice(1, 16);
          displayedSelectedSkills = displayedSkills.slice(1, 9);
        } else {
          newSkills = displayedSkills;
          displayedSelectedSkills = displayedSkills;
        }
        setSkills(prev => [ ...prev, ...newSkills]);
        setSelectedSkills(prev => [ ...prev, ...displayedSelectedSkills])
      } else {
        // console.log("skillsss", props.skills)
        let cacheInfo = getOneFromServerCache("technicalSkills")
        cacheInfo.then(res => res.json())
          .then(res => {
            // console.log("server cache value", res);
            if (res.success === true) {
              if (res.data !== null && res.data !== undefined) {
                let resObj = JSON.parse(res.data);
                // console.log("respObj", resObj);
                dispatch(dispatchSkills(resObj));
                setSkills(resObj?.slice(1, 16));
                setSelectedSkills(resObj?.slice(1, 9));
              }
              // console.log("Done");
            } else if (res.success === false && res.message == "Unauthorized") {
              dispatch(returnHome(res.status));
            }
          }).catch (error => console.log("Error prefilling the current experience company name and title", error))
      }
    } else if (window.location.pathname.includes("/user/profile")) {
      if (p_profile.message !== null) {
        setSkills(p_profile.message?.Skills?.map(e => (e?.value !== undefined ? e.value : e)));
        setSelectedSkills(
          p_profile.message?.Skills?.map((e) =>
            e?.value !== undefined ? e.value : e
          )
        );
      }
    }
  }, []);


    const handleSaveCall = async () => {
        // handleNext(dispatch, firstName, lastName, nextStep);
        try {
            if (selectedSkills?.length !== 0) {
                dispatch(dispatchSkills(selectedSkills));
                // dispatch(combine_skills_loading());
                if (p_profile.message !== null) {
                  dispatch(updateSkills(selectedSkills));
                }
                handleClick();
            } else {
            setTimeout(() => {
                toast.error("At least one skills is required", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }, 50);
            }
        } catch (error) {
            throw error
        }
    }

  const handleCustomSkillsChange = (event) => {
    setCustomSkills(capitalizeWords(event.target.value));
  };

  const handleAddCustomSkills = () => {
    if (customSkills) {
      if (selectedSkills?.length < 8) {
        setSelectedSkills([...new Set([...selectedSkills, customSkills])]);
        setCustomSkills("");
      } else {
        setTimeout(() => {
          toast.error("You have reach maximum skills you can select", {
              position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      }
    }
  };


  return (
    <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 sm:w-[100vw] vsm:w-[100vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
        <div className="sm:max-w-[100vw] vsm:w-[90vw] gap-y-5 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md">
            <h3 className="text-xl font-bold text-[#5843BD] my-4 text-center">Edit Skills</h3>

          <p className="font-medium text-sm text-black text-center mb-6">
            Click on a skill to select it.            
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-4">
            {!window.location.pathname.includes("/user/profile") && skills?.map((skill, index) => (
                <button
                key={index}
                className={`p-3 rounded-md text-center ${selectedSkills.includes(skill) ? 'bg-black text-white' : 'bg-gray-200'}`}
                onClick={() => handleSkillClick(skill)}
                >
                {skill}
                </button>
            ))}
          </div>

          <p className="text-black text-center font-medium text-sm mb-2">
            What other skill would like to add?
          </p>

            <div className="flex vsm:flex-wrap items-center justify-center">
              <input
                type="text"
                className="w-full max-w-[400px] border-2 border-orange-500 rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent md:mr-2"
                placeholder="type your language here"
                value={customSkills}
                onChange={handleCustomSkillsChange}
              />
              <button
                className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded-lg vsm:my-4 my-0 vsm:w-full md:w-auto border-2 max-w-[400px]"
                onClick={handleAddCustomSkills}
              >
                + Add Skill
              </button>
            </div>

          <div>
            <p className="font-bold text-center my-4">You have added:</p>
            <div className="flex flex-wrap item-center justify-center gap-2">
              {selectedSkills?.map((skill, index) => (
                <button key={index} className="rounded-md text-center bg-gray-200 rounded-full px-4 py-2">{skill}</button>
              ))}
            </div>
          </div>
        

          {/* Action buttons */}
          <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-2">
              <div className="flex justify-between lg:max-w-[90vw] w-full">
                  <button
                      onClick={handleClick}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-4 rounded-md"
                  >
                    <span className="notranslate" key={flowLanguage}>
                      {flowLanguage == "Spanish" ? (
                        "Cancelar"
                      ) : (
                        "CANCEL"
                      )}
                    </span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="24" height="24" rx="12" fill="#FF6633"/>
                          <path d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z" fill="white"/>
                      </svg>

                  </button>
                  <button
                      onClick={handleSaveCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                  >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "GUARDAR"
                    ) : (
                      "SAVE"
                    )}
                  </span>
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </div>
          </div>

      </div>
      <ToastContainer />
    </div>
  );
};

export default EditSkill;